export const AdminFooter = () => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="footer">
                    <p className="mb-0">©2025 Protiviti Inc. All Rights Reserved.</p>
                    <p className="mb-0">
                        Protiviti Inc. is an Equal Opportunity Employer, M/F/Disability/Vet
                    </p>
                </div>
            </div>
        </div>
    )
}